import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import Box from "@mui/material/Box";
import "./choose-us.css";
import StudypackLoginModel from "./studyPackAuth/StudypackLoginModel";
import StudyPackRegModel from "./studyPackAuth/StudyPackRegModel";
import { Button, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const StudyPackSection = () => {
  const navigate = useNavigate();

  const [showVideo, setShowVideo] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [openRegModel, setOpenRegModel] = React.useState(false);

  const handleCloseRegModel = () => setOpenRegModel(false);

  const [openLoginModel, setOpenLoginModel] = React.useState(false);

  const handleCloseLoginModel = () => setOpenLoginModel(false);
  return (
    <section>
      <Container>
        <Row>
          <Col lg="6" md="6">
            <div className="choose__content">
              <h2>Study Pack</h2>
              <p>
                Here you can get our premium Study Packs. With getting access to
                a Study Pack you’ll be able to get limitless knowledge to a
                particular lesson. Good luck Poddos!! Fly high🔥
              </p>

              <button
                className="w-20 btn"
                onClick={() => setOpenRegModel(true)}
              >
                Register For Study Pack
              </button>
              <button
                className="w-20 btn"
                onClick={() => setOpenLoginModel(true)}
              >
                Login For Study Pack
              </button>
            </div>
          </Col>

          <Col lg="6" md="6">
            <div
              className="choose__img"
              onClick={() => navigate("/studypacksection")}
              style={{
                cursor: "pointer",
              }}
            >
              <img
                src="https://firebasestorage.googleapis.com/v0/b/s2a-e8459.appspot.com/o/dp%2FstudyPack.png?alt=media&token=fd4fd7ee-28bb-41a1-a889-445012924e4e&_gl=1*jyijut*_ga*MjA4MTY2MzQ3OS4xNjgwNDk4Mzgz*_ga_CW55HF8NVT*MTY4NTUwNDc5Ny44LjEuMTY4NTUwNTA5MS4wLjAuMA.."
                className="w-100"
              />
            </div>
          </Col>
        </Row>
      </Container>
      <Modal
        keepMounted
        open={openRegModel}
        onClose={handleCloseRegModel}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={style}>
          <StudyPackRegModel />
        </Box>
      </Modal>
      <Modal
        keepMounted
        open={openLoginModel}
        onClose={handleCloseLoginModel}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={style}>
          <StudypackLoginModel />
        </Box>
      </Modal>
    </section>
  );
};

export default StudyPackSection;
